import {AggregatedBillingInformationResultDto} from '@app/api/dmc';
import {DateCellComponent} from '@shared/components/table/cells/date-cell/date-cell.component';
import {businessReasonCodePartial} from '@shared/partials/business-reason-code.partial';
import {processVariantPartial} from '@shared/partials/process-variant.partial';
import {meteringPointTypePartial} from '@shared/partials/meteringpointtype-partial.table';
import {settlementmethodPartial} from '@shared/partials/settlementmethod.partial';
import {datahubPartial} from '@shared/partials/datahub.partial';
import {TableConfig} from '@shared/interfaces/table/table-config';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const settlementBillingInformationTable: TableConfig<AggregatedBillingInformationResultDto>  = {
  selectable: true,
  selectableType: 'single',
  columns: [
    {
      title: 'settlement.table.receiveddate',
      key: 'msgCreatedTS',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'settlement.table.startdate',
      key: 'startDate',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'settlement.table.enddate',
      key: 'endDate',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'settlement.wholesale.balancesupplieridentification',
      key: 'balanceSupplierIdentification'
    },
    businessReasonCodePartial,
    processVariantPartial,
    {
      ...meteringPointTypePartial,
      key: 'typeOfMeteringPoint',
    },
    settlementmethodPartial,
    {
      title: 'settlement.wholesale.chargetype',
      key: 'chargeType',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        notspecified: 'enum.chargetype.notspecified',
        subscription: 'enum.chargetype.subscription',
        fee: 'enum.chargetype.fee',
        tariff: 'enum.chargetype.tariff',
      }
    },
    {
      title: 'settlement.wholesale.chargetypeid',
      key: 'chargeTypeId',
    },
    {
      title: 'settlement.wholesale.chargeowner',
      key: 'chargeOwnerEnergyParty',
    },
    {
      title: 'settlement.table.version',
      key: 'version'
    },
    datahubPartial,
  ]
}
